// const BASE_URL = 'http://localhost:8080'; 

const BASE_URL = 'https://tridentsoftwareservice.com'; 


export { BASE_URL};